import { useCallback, useState } from 'react';

import { useHistory } from 'react-router-dom';

import { ImageLogoAtom } from '~/assets/images/';
import { Button } from '~/components';

import {
  Container,
  Header,
  Content,
  Footer,
  CheckboxContainer,
  Checkbox,
} from './styles';

const SignUpTermsOfUse = () => {
  const { push } = useHistory();

  const [checkboxIsFilled, setCheckboxIsFilled] = useState(false);

  const navigateToSignUpPolicyPrivacy = useCallback(() => {
    push('/sign-up/policy-privacy');
  }, [push]);

  return (
    <Container>
      <Header>
        <div className="logo-container">
          <ImageLogoAtom />
        </div>

        <nav>
          <h1>TERMOS DE USO</h1>
        </nav>
      </Header>

      <Content>
        <p>
          <h2>TERMOS E CONDIÇÕES GERAIS DE USO</h2>
          Os serviços do iB – Intelligent Business são fornecidos pela pessoa
          jurídica com a seguinte Razão Social iB.
          <br /> Soluções Inteligentes, com nome fantasia iB – Intelligent
          Business, inscrito no CNPJ: 40.884.183/0001-70.
          <br /> titular da propriedade intelectual sobre software, website,
          aplicativos, conteúdos e demais ativos relacionados à plataforma
          <br /> iB – Intelligent Business.
        </p>

        <p>
          <h2>1º DO OBJETO</h2>A plataforma visa licenciar o uso de seu
          software, website, aplicativos e demais ativos de propriedade
          intelectual, fornecendo ferramentas para auxiliar e dinamizar o dia a
          dia dos seus usuários. <br />A plataforma caracteriza-se pela
          prestação do seguinte serviço: Acesso online do aplicativo através de
          dispositivos mobile e/ou desktop,Gestão financeira, gestão de alunos e
          professores (perfil academia), gestão de alunos (perfil professor),
          acompanhamento de treino (perfil aluno), criação e configuração de
          treinos fitness dentro e fora da academia, hospedagem de informações,
          criação e envio de boletos/faturas, controle de pagamento, controle de
          pacotes vendidos, cadastro de usuários, biblioteca de exercícios,
          banco de dados com exercícios e métodos, laboratório (I.Lab) para
          criação de métodos, segurança de dados. <br />A plataforma realiza a
          venda à distância por meio eletrônico dos seguintes produtos ou
          serviços: iB – Perfil professor (Direito a cadastro de até 300
          alunos), iB – Perfil academia (Direito a cadastro de até 1.000
          alunos).
        </p>

        <p>
          <h2>2º DA ACEITAÇÃO</h2>O presente Termo estabelece obrigações
          contratadas de livre e espontânea vontade, por tempo indeterminado,
          entre a plataforma e as pessoas físicas ou jurídicas, usuárias do iB.
          Intelligent Business.
          <br /> Ao utilizar a plataforma o usuário aceita integralmente as
          presentes normas e compromete-se a observá-las, sob o risco de
          aplicação das penalidade cabíveis.
          <br /> A aceitação do presente instrumento é imprescindível para o
          acesso e para a utilização de quaisquer serviços fornecidos pela
          empresa.
          <br /> Caso não concorde com as disposições deste instrumento, o
          usuário não deve utilizá-los.
        </p>

        <p>
          <h2>3º DO ACESSO DOS USUÁRIOS</h2>
          Serão utilizadas todas as soluções técnicas à disposição do
          responsável pela plataforma para permitir o acesso ao serviço 24
          (vinte e quatro) horas por dia, 7 (sete) dias por semana.
          <br /> No entanto, a navegação na plataforma ou em alguma de suas
          páginas poderá ser interrompida, limitada ou suspensa para
          atualizações, modificações ou qualquer ação necessária ao seu bom
          funcionamento..
        </p>

        <p>
          <h2>4º DO ACESSO DOS USUÁRIOS</h2>O acesso às funcionalidades da
          plataforma exigirá a realização de um cadastro prévio e, a depender
          dos serviços ou produtos escolhidos, o pagamento de determinado valor.
          <br /> Ao se cadastrar o usuário deverá informar dados completos,
          recentes e válidos, sendo de sua exclusiva responsabilidade manter
          referidos dados atualizados, bem como o usuário se compromete com a
          veracidade dos dados fornecidos.
          <br /> O usuário se compromete a não informar seus dados cadastrais
          e/ou de acesso à plataforma a terceiros, responsabilizando-se
          integralmente pelo uso que deles seja feito.
          <br /> Menores de 18 anos e aqueles que não possuírem plena capacidade
          civil deverão obter previamente o consentimento expresso de seus
          responsáveis legais para utilização da plataforma e dos serviços ou
          produtos, sendo de responsabilidade exclusiva dos mesmos o eventual
          acesso por menores de idade e por aqueles que não possuem plena
          capacidade civil sem a prévia autorização.
          <br /> Mediante a realização do cadastro o usuário declara e garante
          expressamente ser plenamente capaz, podendo exercer e usufruir
          livremente dos serviços e produtos.
          <br /> O usuário deverá fornecer um endereço de e-mail válido, através
          do qual o site realizará todas as comunicações necessárias.
          <br />
          Após a confirmação do cadastro, o usuário possuirá um login e uma
          senha pessoal, a qual assegura ao usuário o acesso individual à mesma.
          <br />
          Desta forma, compete ao usuário exclusivamente a manutenção de
          referida senha de maneira confidencial e segura, evitando o acesso
          indevido às informações pessoais.
          <br /> Toda e qualquer atividade realizada com o uso da senha será de
          responsabilidade do usuário, que deverá informar prontamente a
          plataforma em caso de uso indevido da respectiva senha.
          <br /> Não será permitido ceder, vender, alugar ou transferir, de
          qualquer forma, a conta, que é pessoal e intransferível.
          <br /> Caberá ao usuário assegurar que o seu equipamento seja
          compatível com as características técnicas que viabilize a utilização
          da plataforma e dos serviços ou produtos.
          <br /> O usuário poderá, a qualquer tempo, requerer o cancelamento de
          seu cadastro junto ao iB – Intelligent Business.
          <br /> O seu cancelamento será realizado o mais rapidamente possível,
          desde que não sejam verificados débitos em aberto.
          <br /> O usuário, ao aceitar os Termos de uso e Política de
          Privacidade, autoriza expressamente a plataforma a coletar, usar,
          armazenar, tratar, ceder ou utilizar as informações derivadas do uso
          dos serviços, do app e quaisquer plataformas, incluindo todas as
          informações preenchidas pelo usuário no momento em que realizar ou
          atualizar seu cadastro, além de outras expressamente descritas na
          Política de Privacidade que deverá ser autorizada pelo usuário.
        </p>

        <p>
          <h2>5º DOS SERVIÇOS OU PRODUTOS</h2>A plataforma poderá disponibilizar
          para o usuário um conjunto específico de funcionalidades e ferramentas
          para otimizar o uso dos serviços e produtos.
          <br /> Na plataforma os serviços ou produtos oferecidos estão
          descritos e apresentados com o maior grau de exatidão, contendo
          informações sobre suas características, qualidades, quantidades,
          composição, preço, garantia.
          <br /> Antes de finalizar a compra sobre o serviço, o usuário deverá
          se informar sobre as suas especificações e sobre a sua destinação.
          <br /> O acesso aos serviços presentes na plataforma será liberado no
          momento em que o cadastro, bem como o pagamento forem identificados
          por nossa equipe interna.
        </p>

        <p>
          <h2>6º DOS PREÇOS</h2>A plataforma se reserva no direito de reajustar
          unilateralmente, a qualquer tempo, os valores dos serviços ou produtos
          sem consulta ou anuência prévia do usuário.
          <br /> Os valores aplicados são aqueles que estão em vigor no momento
          do pedido.
          <br /> Na contratação dos serviços disponíveis, a plataforma poderá
          solicitar as informações financeiras do usuário, como CPF, endereço de
          cobrança e dados de cartões.
          <br /> Ao inserir referidos dados o usuário concorda que sejam
          cobrados, de acordo com a forma de pagamento que venha a ser
          escolhida, os preços então vigentes e informados quando da
          contratação.
          <br /> Os referidos dados financeiros poderão ser armazenados para
          facilitar acessos e contratações futuras.
          <br /> A contratação dos serviços será renovada automaticamente pela
          plataforma, independentemente de comunicação ao usuário, mediante
          cobrança periódica da mesma forma de pagamento indicada pelo usuário
          quando da contratação do serviço.
        </p>

        <p>
          <h2>7º DOCANCELAMENTO</h2>O usuário poderá cancelar a contratação dos
          serviços de acordo com os termos que forem definidos no momento de sua
          contratação. <br />
          Ainda, o usuário também poderá cancelar os serviços em até 7 (sete)
          dias após a contratação, mediante contato com o suporte comercial
          através do e-mail comercial@ibintelligentbusiness.com, de acordo com o
          Código de Defesa do Consumidor (Lei no. 8.078/90). <br /> O serviço
          poderá ser cancelado por: a) parte do usuário: nessas condições os
          serviços somente cessarão quando concluído o ciclo vigente ao tempo do
          cancelamento; b) violação dos Termos de Uso: os serviços serão
          cessados imediatamente.
        </p>

        <p>
          <h2>8º DO SUPORTE</h2>
          Em caso de qualquer dúvida, sugestão ou problema com a utilização da
          plataforma, o usuário poderá entrar em contato com o suporte, através
          do email suporte@ibintelligentbusiness.com Estes serviços de
          atendimento ao usuário estarão disponíveis nos seguintes dias e
          horários: Segunda a sábado das 8:00hs às 18:00hs.
        </p>

        <p>
          <h2>9º DAS RESPONSABILIDADES</h2>É de responsabilidade do usuário:{' '}
          <br />
          a) defeitos ou vícios técnicos originados no próprio sistema do
          usuário; <br />
          b) a correta utilização da plataforma, dos serviços oferecidos,
          prezando pela boa convivência, pelo respeito e cordialidade entre os
          usuários; <br /> c) pelo cumprimento e respeito ao conjunto de regras
          disposto nesse Termo de Uso, na respectiva Política de Privacidade e
          na legislação nacional e internacional; <br />
          d) pela proteção aos dados de acesso à sua conta/perfil (login e
          senha). <br />
          <br />É de responsabilidade da plataforma iB.Intelligent Business:
          <br /> a) indicar as características do serviço ou produto;
          <br /> b) os defeitos e vícios encontrados no serviço ou produto
          oferecido desde que lhe tenha dado causa; <br />
          c) as informações que foram por ele divulgadas, sendo que os
          comentários ou informações divulgadas por usuários são de inteira
          responsabilidade dos próprios usuários; <br />
          d) os conteúdos ou atividades ilícitas praticadas através da sua
          plataforma.
          <br /> <br />A plataforma não se responsabiliza por links externos
          contidos em seu sistema que possam redirecionar o usuário à ambiente
          externo a sua rede. Não poderão ser incluídos links externos ou
          páginas que sirvam para fins comerciais ou publicitários ou quaisquer
          informações ilícitas, violentas, polêmicas, pornográficas,
          xenofóbicas, discriminatórias ou ofensivas.
        </p>

        <p>
          <h2>10º DOS DIREITOS AUTORAIS</h2>O presente Termo de Uso concede aos
          usuários uma licença não exclusiva, não transferível e não
          sub-licenciável, para acessar e fazer uso da plataforma e dos serviços
          e produtos por ela disponibilizados.
          <br /> A estrutura do site ou aplicativo, as marcas, logotipos, nomes
          comerciais, layouts, gráficos e design de interface, imagens,
          ilustrações, fotografias, apresentações, vídeos, conteúdos escritos e
          de som e áudio, programas de computador, banco de dados, arquivos de
          transmissão e quaisquer outras informações e direitos de propriedade
          intelectual da razão social ___, observados os termos da Lei da
          Propriedade Industrial (Lei no 9.
          <br />
          279/96), Lei de Direitos Autorais (Lei no 9.
          <br />
          610/98) e Lei do Software (Lei no 9.
          <br />
          609/98), estão devidamente reservados.
          <br /> Este Termos de Uso não cede ou transfere ao usuário qualquer
          direito, de modo que o acesso não gera qualquer direito de propriedade
          intelectual ao usuário, exceto pela licença limitada ora concedida.
          <br /> O uso da plataforma pelo usuário é pessoal, individual e
          intransferível, sendo vedado qualquer uso não autorizado, comercial ou
          não-comercial.
          <br /> Tais usos consistirão em violação dos direitos de propriedade
          intelectual da razão social iB – Soluções Inteligentes, puníveis nos
          termos da legislação aplicável.
        </p>

        <p>
          <h2>11º SANÇÕES</h2>
          Sem prejuízo das demais medidas legais cabíveis, a iB – Soluções
          Inteligentes poderá, a qualquer momento, advertir, suspender ou
          cancelar a conta do usuário: <br />
          a) que violar qualquer dispositivo do presente Termo; <br />
          b) que descumprir os seus deveres de usuário; <br />
          c) que tiver qualquer comportamento fraudulento, doloso ou que ofenda
          a terceiros.
        </p>

        <p>
          <h2>12º DA RECISÃO</h2>A não observância das obrigações pactuadas
          neste Termo de Uso ou da legislação aplicável poderá, sem prévio
          aviso, ensejar a imediata rescisão unilateral por parte da razão
          social iB – Soluções Inteligentes e o bloqueio de todos os serviços
          prestados ao usuário.
        </p>

        <p>
          <h2>13º DAS ALTERAÇÕES</h2>
          Os itens descritos no presente instrumento poderão sofrer alterações,
          unilateralmente e a qualquer tempo, por parte da iB – Intelligent
          Business, para adequar ou modificar os serviços, bem como para atender
          novas exigências legais.
          <br /> As alterações serão veiculadas OU pelo site{' '}
          <a
            href="http://www.ibintelligentbusiness.com"
            target="_blank"
            rel="noreferrer"
          >
            http://www.ibintelligentbusiness.com
          </a>{' '}
          OU pelo aplicativo iB – Intelligent Business e o usuário poderá optar
          por aceitar o novo conteúdo ou por cancelar o uso dos serviços, caso
          seja assinante de algum serviço. Os serviços oferecidos podem, a
          qualquer tempo e unilateralmente, e sem qualquer aviso prévio, ser
          deixados de fornecer, alterados em suas características, bem como
          restringido para o uso ou acesso.
        </p>

        <p>
          <h2>14º DA POLÍTICA DE PRIVACIDADE</h2>
          Além do presente Termo, o usuário deverá consentir com as disposições
          contidas na respectiva Política de Privacidade a ser apresentada a
          todos os interessados dentro da interface da plataforma.
        </p>

        <p>
          <h2>15º DO FORO</h2>
          Para a solução de controvérsias decorrentes do presente instrumento
          será aplicado integralmente o Direito brasileiro. <br />
          Os eventuais litígios deverão ser apresentados no foro da comarca em
          que se encontra a sede da empresa.
        </p>

        <p>
          <h2>NOTA COMERCIAL</h2>
          CASO O USUÁRIO PERMANEÇA INATIVO (NÃO PAGANTE) POR MAIS DE 03 MESES,
          ELE TERÁ SEU PERFIL JUNTO COM TODAS AS INFORMAÇÕES, INCLUSIVE DE SEUS
          ALUNOS, DELETADOS DO SERVIDOR.
        </p>
      </Content>

      <Footer>
        <CheckboxContainer
          onClick={() => setCheckboxIsFilled((prevState) => !prevState)}
        >
          <Checkbox isFilled={checkboxIsFilled} />

          <span>Li e concordo com os termos de uso.</span>
        </CheckboxContainer>

        <Button
          onClick={navigateToSignUpPolicyPrivacy}
          buttonDisable={!checkboxIsFilled}
        >
          CONTINUAR
        </Button>
      </Footer>
    </Container>
  );
};

export default SignUpTermsOfUse;
